import React from 'react';
import { Plane, Key, Briefcase, GraduationCap } from 'lucide-react';
import { motion } from 'framer-motion';
const services = [{
  icon: <Plane className="w-8 h-8" data-id="element-170" />,
  title: 'Charter Simplified',
  description: 'Experience seamless private travel with our transparent pricing, guaranteed availability, and premium fleet access.',
  image: 'https://images.unsplash.com/photo-1583416750470-965b2707b355?q=80&w=800&auto=format&fit=crop'
}, {
  icon: <Key className="w-8 h-8" data-id="element-171" />,
  title: 'Owner Services',
  description: 'Comprehensive aircraft management. We handle maintenance, crew, and operations so you can simply enjoy the flight.',
  image: 'https://images.unsplash.com/photo-1540962351504-03099e0a754b?q=80&w=800&auto=format&fit=crop'
}, {
  icon: <Briefcase className="w-8 h-8" data-id="element-172" />,
  title: 'Brokerage',
  description: 'Expert guidance in aircraft acquisitions and sales, backed by deep market intelligence and industry relationships.',
  image: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?q=80&w=800&auto=format&fit=crop'
}, {
  icon: <GraduationCap className="w-8 h-8" data-id="element-173" />,
  title: 'Flight Training',
  description: 'Elevate your skills with our elite flight training programs, from private pilot to advanced type ratings.',
  image: 'https://images.unsplash.com/photo-1629196914212-0168ce02f436?q=80&w=800&auto=format&fit=crop'
}];
export function Services() {
  return <section className="py-24 bg-brand-50" data-id="element-174">
      <div className="max-w-7xl mx-auto px-6" data-id="element-175">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-176">
          <h2 className="text-sm font-bold tracking-widest text-brand-600 uppercase mb-4" data-id="element-177">
            Our Expertise
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-charcoal-900 mb-6" data-id="element-178">
            Elevating Every Aspect of Private Aviation
          </h3>
          <p className="text-gray-600 text-lg" data-id="element-179">
            From seamless charter flights to comprehensive aircraft management
            and acquisitions, PlaneSmart delivers uncompromising excellence.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-180">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} className="group cursor-pointer" data-id="element-181">
              <div className="relative h-64 mb-6 overflow-hidden rounded-2xl" data-id="element-182">
                <div className="absolute inset-0 bg-charcoal-900/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-183" />
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700 ease-out" data-id="element-184" />
                <div className="absolute bottom-4 left-4 z-20 bg-white/90 backdrop-blur p-3 rounded-xl text-brand-600 shadow-lg" data-id="element-185">
                  {service.icon}
                </div>
              </div>
              <h4 className="text-xl font-serif font-semibold text-charcoal-900 mb-3 group-hover:text-brand-600 transition-colors" data-id="element-186">
                {service.title}
              </h4>
              <p className="text-gray-600 leading-relaxed" data-id="element-187">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}